<app-pagetitle title="Modelo de Documentos" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-xl-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Configure modelos de documentos</h4>
                <p class="card-title-desc">Estes modelos de docuentos são usados para gerar respectivos documentos.</p>


                <ngb-alert [dismissible]="false" class="mt-3 mb-0" type="warning">
                    <h4 class="alert-heading">Atenção!</h4>
                    <p>Envie apenas documentos WORD (.docx).</p>

                </ngb-alert>


            </div><!-- end card header -->

            <div class="card-body">
                <div class="row">
                    @if(settingService.loading) {
                    <div class="d-flex justify-content-center align-items-center" style="height: 150px">
                        <span class="spinner-border" style="width: 3rem; height: 3rem" role="status"
                            aria-hidden="true"></span>
                    </div>
                    } @else {
                    <div class="col-md-3">
                        <ul ngbNav #verticalNav="ngbNav" [activeId]="1" class="nav-pills flex-column">
                            <li [ngbNavItem]="1">
                                <a ngbNavLink class="mb-2">
                                    <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                                    <span class="d-none d-sm-block">Contrato</span>
                                </a>

                                <ng-template ngbNavContent>
                                    @if(!hasContratoDocumentContrato()){
                                    <form [formGroup]="documentForm" (ngSubmit)="onSubmit(4)">
                                        <div class="col-xl-6">

                                            <div class="form-group">
                                                <label class="form-label" for="contato">Documento Modelo
                                                    Contrato</label>
                                                <input 
                                                    type="file"
                                                    formControlName="document"
                                                    class="form-control" 
                                                    (change)="onChange($event)"
                                                    accept=".docx"
                                                />
                                                <div style="color: red;"
                                                *ngIf="documentForm.get('document')?.invalid &&
                                                    documentForm.get('document')?.touched">
                                                    Um documento deve ser selecionado
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex mt-3">
                                            <button class="btn btn-success waves-effect waves-light" type="submit">
                                                Enviar arquivo
                                            </button>
                                        </div>
                                    </form>
                                    <p class="mb-0 mt-4"> Este Documento será usado como Layout base para construção
                                        de
                                        todos os documentos de contratos gerados pelo sistema.</p>
                                    }@else{
                                    <div class="col-xl-12">
                                        <div class="col-xl-6">
                                            <div class="event-content">
                                                <div class="timeline-text">
                                                    <h3 class="font-size-18">Documento já cadastrado</h3>
                                                </div>
                                                <button (click)="downloadDocument('contrato')" type="button" class="btn btn-primary btn-sm waves-effect waves-light">Baixar</button>
                                               
                                            </div>
                                        </div>

                                        <div class="col=xl-6 mt-4">
                                            <div class="timeline-text">
                                                <h3 class="font-size-18">Deseja excluir o documento atual?</h3>
                                                
                                            </div>
                                            
                                            <button (click)="openModal('contrato', 4)" type="button"
                                                data-bs-target="#staticBackdrop" data-bs-toggle="modal"
                                                class="btn btn-danger waves-effect btn-sm btn-label waves-light"><i
                                                    class="bx bx-block label-icon"></i> Excluir documento</button>
                                        </div>
                                    </div>

                                    }

                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <a ngbNavLink class="mb-2">
                                    <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                                    <span class="d-none d-sm-block">Proposta Comercial</span>
                                </a>
                                <ng-template ngbNavContent>
                                    @if(!hasPropostaDocumentContrato()){
                                        <form [formGroup]="documentForm" (ngSubmit)="onSubmit(3)">
                                            <div class="col-xl-6">
    
                                                <div class="form-group">
                                                    <label class="form-label" for="contato">Documento Modelo
                                                        Proposta Comercial</label>
                                                    <input 
                                                        type="file"
                                                        formControlName="document"
                                                        class="form-control" 
                                                        (change)="onChange($event)"
                                                        accept=".docx"
                                                    />
                                                    <div style="color: red;"
                                                    *ngIf="documentForm.get('document')?.invalid &&
                                                        documentForm.get('document')?.touched">
                                                        Um documento deve ser selecionado
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex mt-3">
                                                <button class="btn btn-success waves-effect waves-light" type="submit">
                                                    Enviar arquivo
                                                </button>
                                            </div>
                                        </form>
                                        <p class="mb-0 mt-4"> Este Documento será usado como Layout base para construção
                                            de
                                            todos os documentos de contratos gerados pelo sistema.</p>
                                        }@else{
                                        <div class="col-xl-12">
                                            <div class="col-xl-6">
                                                <div class="event-content">
                                                    <div class="timeline-text">
                                                        <h3 class="font-size-18">Documento já cadastrado</h3>
                                                    </div>
                                                    <button (click)="downloadDocument('proposta')" type="button" class="btn btn-primary btn-sm waves-effect waves-light">Baixar</button>
                                                   
                                                </div>
                                            </div>
    
                                            <div class="col=xl-6 mt-4">
                                                <div class="timeline-text">
                                                    <h3 class="font-size-18">Deseja excluir o documento atual?</h3>
                                                    
                                                </div>
                                                
                                                <button (click)="openModal('proposta', 3)" type="button"
                                                    data-bs-target="#staticBackdrop" data-bs-toggle="modal"
                                                    class="btn btn-danger waves-effect btn-sm btn-label waves-light"><i
                                                        class="bx bx-block label-icon"></i> Excluir documento</button>
                                            </div>
                                        </div>
    
                                        }
    
                                </ng-template>
                            </li>

                        </ul>
                    </div>
                    <div class="col-md-9">
                        <div [ngbNavOutlet]="verticalNav" class="text-muted"></div>
                    </div>
                    }

                </div><!-- end row -->
            </div><!-- end card-body -->
        </div><!-- end card -->
    </div><!-- end col -->

</div><!-- end row -->

<app-modal-excluir  
    [title]="'Excluir Modelo de Documento'"
    [text]="'Modelo de documento será excluído definitivamente. Deseja continuar?'"
    (confirmDelete)="handleDelete($event)">
</app-modal-excluir>


     